import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { SITE } from "../data/site";
import { PageHero, Reveal, CallButton, PartyButton } from "../components/Shared";

const faqs = [
  {
    q: "What are your hours?",
    a: "Winter hours — Friday–Sunday: 2:30–5:30 PM. Monday–Thursday: Closed.",
  },
  {
    q: "Where are you located?",
    a: `You'll find us at ${SITE.address}.`,
  },
  {
    q: "Do you offer birthday parties?",
    a: `Yes! Ms. Jeanette's offers a $${SITE.party.price} birthday party package for up to ${SITE.party.maxKids} children.`,
  },
  {
    q: "How long is the birthday party?",
    a: "The party is 2 hours.",
  },
  {
    q: "What is included?",
    a: "Each child receives a small snowball. The party also includes the party area, Reading Tree, birthday photo area, and Happy Birthday yard-card display.",
  },
  {
    q: "How much is the birthday deposit?",
    a: `A $${SITE.party.deposit} nonrefundable booking deposit is required and goes toward the $${SITE.party.price} party total.`,
  },
  {
    q: "Can I book a birthday party online?",
    a: "No online booking system is currently being used. Birthday party reservations are handled directly through Ms. Jeanette.",
  },
  {
    q: "How do I book?",
    a: `Call ${SITE.phone} or email ${SITE.email}.`,
  },
  {
    q: "Do you offer drive-through service?",
    a: "Yes!",
  },
  {
    q: "Do you have outdoor seating?",
    a: "Yes!",
  },
  {
    q: "What is the Reading Tree?",
    a: "The Reading Tree is a special area where children can read, explore whimsical decorations and little doors, and earn rewards — read a book by the tree for 20 minutes and get a free small snowball.",
  },
];

export default function FAQ() {
  return (
    <>
      <PageHero
        eyebrow="Good to know"
        title="Frequently Asked Questions"
        sub="Everything parents ask us most — hours, parties, deposits, and the Reading Tree."
        testid="faq-hero"
      />

      <section className="px-4 py-20 sm:px-6" data-testid="faq-list-section">
        <Reveal className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={faq.q}
                value={`item-${i}`}
                className="rounded-3xl border border-blue-100 bg-white px-6 shadow-md shadow-blue-500/5"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-left font-display text-lg font-semibold text-slate-900 hover:no-underline" data-testid={`faq-question-${i}`}>
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm font-semibold text-slate-600 sm:text-base" data-testid={`faq-answer-${i}`}>
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>

      <section className="bg-blue-600 px-4 py-20 text-center sm:px-6" data-testid="faq-cta-section">
        <Reveal>
          <h2 className="text-3xl font-semibold text-white sm:text-4xl">Still Have a Question?</h2>
          <p className="mx-auto mt-4 max-w-xl text-base font-semibold text-blue-100 md:text-lg">
            Ms. Jeanette is just a phone call away.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <CallButton testid="faq-cta-call-btn" light />
            <PartyButton testid="faq-cta-party-btn" />
          </div>
        </Reveal>
      </section>
    </>
  );
}
